import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateReportForm } from '@/features/create-report-form'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/reports/vouchers/create')({
  staticData: {
    meta: {
      title: 'Создать отчет по ваучерам',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Заказать отчёт')}>
      <CreateReportForm onClose={close} reportType="voucher" />
    </Offcanvas>
  )
}
